import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useGetUserSession } from "../useQuery/user/useGetUserSession";

import { useUserStore } from "../zustand/useStore";

import { AppSidebar } from "@/components/organisms/AppSidebar";
import { NavigationBar } from "@/components/organisms/NavigationBar";
import { SidebarProvider } from "@/components/ui/sidebar";
import { SIDEBAR_NAMES } from "@/constants/sidebar";
// import { DevSidebar } from "@/features/dev/components/organisms/DevSidebar";
import { HelpSidebar } from "@/features/help/components/organisms/HelpSidebar";
import { useUserData } from "../../features/user/hooks/useQuery/useUserData/useUserData";

export default function Root() {
    const navigate = useNavigate();
    const location = useLocation();

    const { data: userSession, isLoading } = useGetUserSession();


    useEffect(() => {
        if (isLoading) return;
        if (location.pathname === '/') {
            if (userSession) {
                navigate('/welcome');
            } else {
                navigate('/login');
            }
        }
    }, [location, navigate, userSession, isLoading])
    const userStore = useUserStore(state => state);
    const { data: user } = useUserData();


    if (user?.first_name && user?.last_name) {
        userStore.first_name = user?.first_name;
        userStore.last_name = user?.last_name;
    }
    const { data: session } = useGetUserSession();
    const setSession = useUserStore(state => state.setSession);

    useEffect(() => {
        setSession(session);
    }, [session, setSession]);


    return (
        <SidebarProvider
            className="flex flex-1"
            sidebarNames={Object.values(SIDEBAR_NAMES)}
            style={{
                "--sidebar-width": "20rem",
            } as React.CSSProperties}
            defaultOpen={[]}
        >
            {/* <DevSidebar> */}
                <AppSidebar />
                <div className="flex flex-col items-center flex-1">
                    <NavigationBar />
                    <Outlet />
                </div>
                <HelpSidebar />
            {/* </DevSidebar> */}
        </SidebarProvider>
    )
}